
<template>
  <div class="box" ref="box">
    <div class="rule-show-box" v-if="ruleObj.show">
      <div class="pop-rule" v-if="ruleObj.show">
        <div class="ctrl">
          <i class="icon icon-close-range" @click="ruleObj.show = false"></i>
        </div>
        <div class="info">
          <div class="info-item" v-for="(rule,index) in ruleObj.rules">
            <div class="title" v-if="rule.title">{{rule.title | i18n}}</div>
            <div class="text" v-for="(line,i) in rule.desc" v-if="line">{{line | i18n}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="reward-rank-comp" v-else-if="showRewardRank">
      <rewardRank @close="showRewardRank = false"></rewardRank>

    </div>
    <div class="gameing" :class="noPaddin?'no-paddin':''"  v-else>
      <template>
        <template v-if="!selectOption.game">
          <template v-if="games.length != 0 && games[0].options.length <= 2">
            <div class="admin-tips" v-if="games.length != 0">
              {{getDict(40)}}
            </div>
            <div class="games-box">
              <div
                class="game-block" 
                v-for="(item,index) in games"
                :class="
                  item.right_choice >= 0?
                    (item.right_choice == 0?'win-option-yes':'win-option-no'):''
                "
              >
                <div class="color-bg">
                  <div class="title">
                    <div class="game-name">{{item.name}}</div>
                    <div class="end-time">
                      <template v-if="item.end_ts > nowTime">
                        <span class="status">
                          <span class="line"></span>
                          <span>{{getDict(41) | formatDict($filters.formatDate(item.end_ts,'HH:mm'))}}</span>
                          <span class="line"></span>
                        </span>
                      </template>
                      <template v-else>
                        <span class="not-gaming">
                          <span class="status">
                            <span class="line"></span>
                            <span>{{item.right_choice != -1?getDict(42):getDict(43)}}</span>
                            <span class="line"></span>
                          </span>
                          <span class="cash" v-if="guessBetsMap[item.guess_id] && item.right_choice != -1">
                            <i class="icon icon-gold"></i>
                            <span 
                              v-if="guessBetsMap[item.guess_id].choice == item.right_choice"
                            >
                              +{{guessBetsMap[item.guess_id].won_money}}
                            </span>
                            <span 
                              v-if="guessBetsMap[item.guess_id].choice != item.right_choice"
                            >
                              -{{guessBetsMap[item.guess_id].money}}
                            </span>
                          </span>
                        </span>
                      </template>
                    </div>
                  </div>
                  <div class="select-block">
                    <div class="select">
                      <div class="options">
                        <div class="option-item option-yes">
                          <span @click="selectGambleOption(item,item.options[0])">{{item.options[0].content}}</span>
                        </div>
                        <div class="vs">VS</div>
                        <div class="option-item option-no">
                          <span @click="selectGambleOption(item,item.options[1])">{{item.options[1].content}}</span>
                        </div>
                      </div>
                    </div>
                    <!-- <div class="selected-sum">
                      <div 
                        class="select-yes" 
                        :style="{
                          width:(item.options[0].count + item.options[1].count?
                            (item.options[0].count/(item.options[0].count + item.options[1].count))*100
                            :50) + '%',
                        }"
                      ></div>
                      <span>{{
                        item.options[0].count + item.options[1].count?
                          Math.round(item.options[0].count/(item.options[0].count + item.options[1].count) *10000)/100
                          :50
                      }}%</span>
                      <span>{{
                        item.options[0].count + item.options[1].count?
                          Math.round(item.options[1].count/(item.options[0].count + item.options[1].count) *10000)/100
                          :50
                      }}%</span>
                    </div> -->
                    <!-- <div class="win-cash">
                      <span>赔率{{item.options[0].odds}}</span>
                      <span>赔率{{item.options[1].odds}}</span>
                    </div> -->
                  </div>
                </div>
                
              </div>
            </div>
          </template>

          <!-- 多选项》 -->
          <div class="more-option" v-if="moreOptionGamble && moreOptionGamble.options.length > 2">
            <div class="title">
              <div class="game-name">{{moreOptionGamble.name}}</div>
              <div class="end-time">
                <template  v-if="moreOptionGamble.end_ts > nowTime">
                  <span>{{getDict(41) | formatDict($filters.formatDate(moreOptionGamble.end_ts,'HH:mm'))}}</span>
                  <!-- <span>{{moreOptionGamble.end_ts | formatDate('HH:mm')}} {{getDict(41)}}</span> -->
                  
                </template>
                <template v-else>
                  <span class="not-gaming">
                    <span >{{moreOptionGamble.right_choice != -1?getDict(42):getDict(43)}}</span>
                   <!--  <span class="cash">
                      <i class="icon icon-gold"></i>
                      <span>+1231</span>
                    </span> -->
                  </span>
                </template>
              </div>
            </div>
            <div class="options" v-if="moreOptionGamble">
              <div class="option-item" v-for="(option,index) in moreOptionGamble.options">
                <div class="win-icon" v-if="moreOptionGamble.right_choice == index">
                  <span>win</span>
                </div>
                <div class="option-name">{{option.content}}</div>
                <div class="btn" :class="option._select?'selected':''">
                  <div 
                    class="select-btn "
                     @click="selectGambleOption(moreOptionGamble,option)"
                  >
                    {{option._select?getDict(44):getDict(45)}}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 《多选项 -->
        </template>
        
        <div class="selecting-option" v-if="selectOption.game">
          <div class="top-ctrl">
            <i class="icon icon-close-range" @click="closeSelectGambleOption"></i>            
          </div>
          <div class="title">{{selectOption.game.name}}</div>
          <div class="select-option">{{getDict(46) | formatDict(selectOption.select.content)}}</div>
          <div class="buy-num">
            <div class="input-num">
              <input v-model="buyNum"  type="number" name="" :placeholder="getDict(47)">
            </div>
            <div class="default-num">
              <div class="value" @click="()=>{buyNum = item.value}" v-for="(item,index) in defaultNum">{{item.name}}</div>
            </div>
            <!-- <div class="can-get">
              <span class="text">猜對可得</span>
              <span class="value">{{(+buyNum ||0) * selectOption.select.odds | readableNum}}</span>
            </div> -->
          </div>
          <div class="submit" @click="submitGamble">{{getDict(45)}}</div>
        </div>
      </template>
      <div class="no-game" v-if="games.length == 0 && !loading">
        <div class="img">
          <i class="icon icon-no-gamble"></i>
        </div>
        <div class="tips">
          <span>{{getDict(48)}}</span>
        </div>
      </div>
      

    </div>
    
    <div class="money-box">
      <span>
        <i class="icon icon-gold"></i>
        <span class="num">{{userData.money | readableNum}}</span>
        <span class="tips-btn" @click="ruleObj.show = true">?</span>
      </span>
      <span class="rank-btn" @click="showRewardRank = true">
        <i class="icon icon-rank"></i>
        <span>{{getDict(80)}}</span>
      </span>


      
    </div>

    <div class="float-box" v-if="popTips">
      <div class="pop-tips" v-if="popTips">
        <div class="ctrl">
          <i class="icon icon-close-range" @click="popTips = ''"></i>
        </div>
        <div class="text">{{popTips}}</div>
      </div>
    </div>
    
  </div>
  
</template>

<script>

  import { bus, getDict, axios, webSocket  } from '../common'
  import { invokeNative } from '../common'
  import { listen, unlisten } from '../common/invokeNative'
  import rewardRank from '../components/rewardRank'
  import { mapState, mapGetters } from 'vuex'

  const rules = [{
    title:{
      zht:'競猜玩法介紹',
      jp:'勝敗予想のルール',
      en:'Contest Guess Guide',
    },
    desc:{
      zht:`官方發起競猜後，點擊直播間競猜按鈕，即可查看競猜內容；
        使用競猜幣參與投注，選擇下注選項，下注選項與結果一致則獲勝；
        每輪競猜結束後，系統會根據雙方選項及投注競猜幣實时計算獲勝方應得收益，會在直播間內顯示競猜結果以及您的收益或虧損；
        競猜收益將會進入您的帳戶中，請耐心等待，您也可以進入個人中心【我的競猜】頁面中查看詳細的競猜記錄；`,
      jp:`1.勝敗予想開始後、生放送の【勝敗予想】ボタンをクリックして勝敗予想の内容が表示されます。
        2.予想するオプションを選択して、メダルでベットします。選んだオプションが結果と一致すれば勝ちます。
        3.予想終了後、システムが各オプションにかけられた金額によって、勝者の収益を計算します。当生放送ページにあなたの収益あるいは損失が表示されます。
        4.予想の収益はあなたのアカウントに入ります、少々お待ちください。【プロフィール】の【勝敗予想】で「過去の予想」を見ることができます。`,
      en:`After the official launch a contest guess, click the「Contest Guess」button in the live room to check the content;
        Using tokens to place bet and you’ll win if your option is consistent with the result;
        After each round of contest guess, the system will calculate the winner's gains in real time according to the options of and placed bet of both sides. The results and your gains and losses will be displayed in the live room.
        The gains will be deposited into your account automatically, please be patient for a while. And you can go to「My Space - Contest Guess」to check the detailed guess records;`,
    }
  },{
    title:{
      zht:'競猜幣獲得管道',
      jp:'メダルを得る方法',
      en:'Way To Gain Tokens',
    },
    desc:{
      zht:`競猜幣是實況中心的通用貨幣，競猜幣可以通過以下方式獲得，獲得的競猜幣可以打賞喜歡的主播，主播也可獲得相對應的讚賞值；
        1、可前往個人中心進行簽到，每日可簽到一次，每日簽到可獲得1000競猜幣；
        2、觀看直播領取競猜幣，進入直播見後左下角有個競猜幣倒計時按鈕，1分鐘/3分鐘/6分鐘倒數計時完成後，分別可領取300/800/1100競猜幣，每日一共可以循環三次；
        3、首次關注主播可領取1000競猜幣，取消再重新關注該主播不再獲得競猜幣獎勵；`,
      jp:`メダルは実況センターの通貨で、お気に入りの実況者に贈ることができます。メダルをもらった実況者も評価値も取得できます。
        メダルは以下の方法で取得できます。
        1.【プロフィール】で一日に一度サインインすることができます。1回サインインするとメダル1000個を得ることができます。
        2.生放送を見てメダルを獲得できます。生放送ページで、左下には時があります。1分/ 3分/ 6分になると、それぞれ300/800/1100個のメダルを受け取ることができます。 1日に3回まで繰り返せます。
        3、あるチャンネルを初めて登録すると、1000メダルを受け取ることができます。登録を解除して再登録すると、メダルは受け取れません。`,
      en:`Tokens are the current money of Live and you can use obtained tokens to tip your favorite streamers, helping them gain the appreciation points. Tokens can be obtained as following:
        1. Check in in My Space. You can sign in to get 1000 tokens once per day.
        2. Watch the live streams to collect the tokens. After entering the live, there is a「Contest Guess」 button in the lower left corner. When 1 minute/3 minutes/6 minutes countdown is completed, you can claim 300/800/1100 tokens, which will be looped three times per day.
        3. Subscribing steamer for the first time can obtain 1000 tokens. However, Unsubscribe from the streamer and then subscribe again will no longer gain the reward;`,
    }
  },{
    title:{
      zht:'每週主播榜單規則：',
      jp:'毎週の実況者ランキングのルール：',
      en:'Streamer Ranking Rules (per week):',
    },
    desc:{
      zht:`系統會根據主播在一周內累計獲得的讚賞值總數進行排名，展示每週獲得“讚賞值”最高的5位主播；`,
      jp:`システムは、実況者が1週間に累積した評価値に従ってランク付けし、1週間に「評価値」の上位5人の実況者を表示します。`,
      en:`The system will rank the appreciation points that streamers have accumulated within a week, and then show the Top 5 per week.`,
    }
  },{
    title:{
      zht:'每週觀眾榜單規則：',
      jp:'毎週のオーディエンスリストのルール',
      en:'Audience Ranking Rules (per week)：',
    },
    desc:{
      zht:`系統會根據玩家在一周內累計打賞給主播的競猜幣總數進行排名，展示每週打賞額度最高的5位玩家；`,
      jp:`システムは、プレイヤーが1週間に実況者に贈ったメダルの数をランク付けし、贈ったメダルが多い上記5人のプレイヤーを表示します。`,
      en:`The system will rank the tipping that the audience have tipped within a week, and show the Top 5 per week.`,
    }
  },{
    title:{
      zht:'',
    },
    desc:{
      zht:`競猜玩法最終解釋權歸《荒野行動》團隊所有`,
      jp:`「勝敗予想のルール」の最終解釈権は「荒野行動」チームに属します。`,
      en:`Official of Knives Out reserves the right of final interpretation for the content hereinabove.`,
    }
  },]


  export default {
    props: {
      videoId:{},
    },
    data(){
      return {
        enterTime:0,
        nextGetTime:-1,
        loading:true,
        games:[
          /*{
            name:'競猜主題競猜主題主題',
            end_ts:1560955145219,
            right_choice:1,
            options:[{
              content:'能',
              odds:5.7,
              count:59,
            },{
              content:'不能',
              odds:1.7,
              count:79,
            }]
          },{
            name:'競猜主題競猜主題主題',
            end_ts:'13123',
            right_choice:0,
            options:[{
              content:'能',
              odds:5.7,
              count:59,
            },{
              content:'不能',
              odds:1.7,
              count:79,
            }]
          },{
            name:'競猜主題競猜主題主題',
            end_ts:'13123',
            right_choice:-1,
            options:[{
              content:'能',
              odds:5.7,
              count:59,
            },{
              content:'不能',
              odds:1.7,
              count:79,
            }]
          },{
            name:'競猜主題競猜主題主題',
            end_ts:'13123',
            right_choice:-1,
            options:[{
              content:'能',
              odds:5.7,
              count:59,
            },{
              content:'不能',
              odds:1.7,
              count:79,
            }]
          },{
            name:'競猜主題競猜主題主題',
            end_ts:'13123',
            right_choice:-1,
            options:[{
              content:'能',
              odds:5.7,
              count:59,
            },{
              content:'不能',
              odds:1.7,
              count:79,
            }]
          }*/
        ],
        showRewardRank:false,
        guess_bets:[],
        selectOption:{
          game:null,
          select:null,
        },
        buyNum:'',
        defaultMap:[
          {
            name:'100',
            value:100,
          },
          {
            name:'1000',
            value:1000,
          },
          {
            name:'10000',
            value:10000,
          },
          {
            name:'All in',
            value:'All in',
          }
        ],
        popTips:'',
        ruleObj:{
          show:false,
          rules:rules.map(rule=>{
            return {
              title:rule.title,
              desc:this.$filters.i18n(rule.desc).split(/\n\s*/),
            }
          }),/*[{
            title:'竞猜玩法介绍',
            desc:[
              ...(`官方发起竞猜后，点击直播间竞猜按钮，即可查看竞猜内容；
              使用竞猜币参与投注，选择下注选项，下注选项与结果一致则获胜；
              每轮竞猜结束后，系统会根据双方选项及投注竞猜币实时计算获胜方应得收益，会在直播间内显示竞猜结果以及您的收益或亏损；
              竞猜收益将会进入您的账户中，请耐心等待，您也可以进入个人中心【我的竞猜】页面中查看详细的竞猜记录；`.split('\n'))
            ]
          }]*/
        },
      }
    },
    computed:{
      ...mapState(['userData','goingTime']),
      noPaddin(){
        return !!this.selectOption.game || !!this.moreOptionGamble;
      },
      nowTime(){
        return this.enterTime + this.goingTime;
      },
      defaultNum(){
        return this.defaultMap.map((node)=>{
          if(typeof node.value == 'string'){
            return {
              ...node,
              value:this.userData.money,
            }
          }
          return node;
        })
      },
      moreOptionGamble(){

        if(this.games[0] && this.games[0].options && this.games[0].options.length > 2){
          let item = {
            ...JSON.parse(JSON.stringify(this.games[0])),
            _allCount:0,
          }
          for(let node of item.options){
            item._allCount += +node.count||0;
          }
          for(let select of this.guess_bets){
            if(select.guess_id == this.games[0].guess_id){
              item.options[select.choice].odds = select.odds;
              item.options[select.choice]._select = true;
            }
          }
          return item;
        }
      },
      guessBetsMap(){
        let map = {};
        for(let node of this.guess_bets){
          map[node.guess_id] = node;
        }
        return map;
      }
    },
    watch:{
      goingTime(){
        if(this.nextGetTime < this.nowTime && this.nextGetTime >0){
          this.getGamble()
        }
      },
      'userData.uid'(){
        if(this.userData.uid){
          this.getGamble();
        }
        
      },
    },
    components: {
      rewardRank
    },
    methods: {
      getDict,
      initEnterTime(){
        let now = (new Date()).getTime();
        this.enterTime = now - this.goingTime;
      },
      selectGambleOption(game,option){
        if(game.end_ts <= this.nowTime){
          this.popTips = getDict(49);
          return;
        }
        if(game.options.length <= 2){
          if(this.guessBetsMap[game.guess_id]){
            this.popTips = getDict(74);
            return;
          }
        }else{
          if(option._select){
            this.popTips = getDict(74);
            return;
          }
        }
        this.selectOption.game = game;
        this.selectOption.select = option;
      },
      async submitGamble(){
        if(+this.buyNum > this.userData.money){
          this.popTips = getDict(71);
          return;
        }
        if(+this.buyNum < 0 || !+this.buyNum){
          this.popTips = getDict(47);
          return;
        }
        let obj = {
          guess_id: this.selectOption.game.guess_id,
          choice: this.selectOption.game.options.indexOf(this.selectOption.select),
          money: +this.buyNum,
          odds: this.selectOption.select.odds,
        }
        try{
          await webSocket.get('/live/guess/bet',{
            guess_id:obj.guess_id ,// 竞猜id
            choice:obj.choice ,//投注哪个，从0开始表示哪个
            money:obj.money ,//投注多少钱
            odds:obj.odds    //目前赔率，因为赔率会变，所以前端需要发看到的赔率过来跟服务端做对比
          });
          this.guess_bets.push(obj);
        }catch(res){
          if(res.err_msg.indexOf('no enough money') != -1){
            this.popTips = getDict(71);
          }else if(res.err_msg.indexOf('guess end') != -1){
            this.popTips = getDict(49);
          }
        }
        this.closeSelectGambleOption();
        this.$store.dispatch('getUserData');
      },
      closeSelectGambleOption(){
        this.selectOption.game = null;
        this.selectOption.select = null;
        this.buyNum = '';
      },
      async getGamble(){
        this.nextGetTime = this.nowTime + 30 * 1000;
        let data = await webSocket.get('/live/room/info',{
          room_id: this.videoId,//直播间id
        });
        this.games = data.guesses || [];
        this.guess_bets = data.guess_bets || [];
        this.loading = false;
        
      },
    },
    mounted(){
    },
    created(){
      this.initEnterTime();
      if(this.userData.uid){
        this.getGamble();
      }
      
    },
    beforeDestroy(){
    }
  }
</script>

<style lang="scss" scoped>
  .box{
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    background: rgba(40,40,40,1);
    // padding: 0.1rem;
    // padding-bottom:0;
    position: relative;
    

    .money-box{
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0.1rem;
      position: relative;
      height: 0.55rem;
      font-size: 0.25rem;

      .icon-gold{
        $size:0.3rem;
        width: $size;
        height: $size;
        // background-color: #fff;
        vertical-align:bottom;
      }
      .num{
        
        color: #ffc44f;
      }
      .tips-btn{
        margin-left: 0.1rem;
        $size:0.24rem;
        $font-size:$size *0.9 ;
        display: inline-block;
        width: $size;
        height: $size;
        font-size: $font-size;
        line-height: $size;
        text-align: center;
        background-color: #999897;
        border-radius: 50%;
      }
      .rank-btn{
        color: #ffc44f;
        .icon{
          vertical-align: bottom;
          margin-right: 0.01rem;
        }

        .lang-jp & {
          font-size: 0.2rem;
        }
        .lang-en & {
        }
      }

      
    }

    .float-box{
      position: absolute;
      width: 100%;
      height: 100%; 
      display: flex;
      align-items: center;
      left: 0;

      .pop-tips{
        background: rgba(0,0,0,0.8);
        color: #fff;
        text-align: center;
        padding: 0.1rem;
        line-height: 0.3rem;
        width: 100%;
        .ctrl{
          display: flex;
          justify-content: flex-end;
          margin-bottom: 0.1rem;
        }
        .text{
          font-size: 0.2rem;
        }
        
      }
      
    }
    

    .admin-tips{
      $font-size: 0.17rem;
      color: #acacac;
      background-color: #5f5f5f;
      padding:  0.05rem;
      padding-top: 0;
      margin-bottom: 0.1rem;
      font-size: $font-size;
      line-height: $font-size * 1.5;
    }
    
    .gameing{
      $font-size: 0.17rem;
      font-size:$font-size;
      color: #fff; 
      line-height: $font-size * 1.3;
      flex: 1;
      min-height: 0;
      height: 100%;
      display: flex;
      flex-direction: column;

      margin: 0.1rem;
      margin-bottom:0;
      &.no-paddin{
        margin:0;
      }
      

      //=========================
      .games-box,.more-option{
        display: flex;
        flex-direction: column;
               
      }

      .games-box{
        overflow: scroll;
        .game-block{
          $color-yes:#ae3734;
          $color-no:#35619b;
          $color-lose:#676767;
          $deg:20;
          
          &:not(:first-child){
            margin-top: 0.02rem;
          }
          background: linear-gradient(to right , #{$color-yes} 0%, #fff 50%, #{$color-no} 100%);
          position: relative;
          &.win-option-yes{
            background: linear-gradient(to right , #{$color-yes} 0%, #fff 50%, #{$color-lose} 100%);
            .option-item.option-no,.selected-sum{
              background-color: $color-lose !important;
            }
          }
          &.win-option-no{
            background: linear-gradient(to right , #{$color-lose} 0%, #fff 50%, #{$color-no} 100%);
            .option-item.option-yes, .selected-sum .select-yes{
              background-color: $color-lose !important;
            }
          }
          .color-bg{
            background-color: rgba(255,255,255,0.6)
          }
          .select-block{

            padding: 0.1rem;
            padding-top: 0;
            
          }
          .title{
            // background-color: #7885a3;
            text-align: center;
            $font-size: 0.2rem;
            // line-height: $font-size *1.5;
            padding: 0.05rem 0;

            .game-name{
              font-size: $font-size;
              color: #000;
              font-weight: 600;
            }
            .end-time{

              
              color: #4f586e;
              position: relative;


              .not-gaming{
                // color: #4f586e;
                display: inline-block;
                

                .status{
                  $status-font-size:$font-size * 0.7;
                  font-size: $status-font-size;
                  height: 100%;
                  display: inline-block;
                  display: inline-flex;
                  align-items: center;
                  vertical-align: middle;
                  span{
                    // vertical-align: middle;
                  }
                  .line{ 
                    transform: scaleY(0.5);
                    display: inline-block;
                    vertical-align: baseline;
                    margin:0 0.05rem;
                    height:0;
                    width: 0.2rem;
                    border-top: 0.01rem solid #4f586e;
                    content:"";
                  }
                }
                .cash{
                  $cash-font-size:$font-size * 0.8;
                  position: absolute;
                  right: 0.05rem;
                  color: #4f586e;
                  display: inline-flex;
                  align-items: center;
                  .icon-gold{
                    width: $cash-font-size * 1;
                    height: $cash-font-size * 1;
                    // vertical-align: middle;
                    margin-right: 0.01rem;
                  }
                  span{
                    // vertical-align: middle;
                    display: inline-block;
                    font-size: $cash-font-size;
                    margin-left: 0.02rem;
                  }
                }
                
              }
            }
          } 

          .select{
           
            .options{
              $font-size: 0.2rem;
              
              $qie-jiao-width:0.2rem;
              display: flex;
              justify-content: space-between;
              .vs, .option-item{
                display: inline-block;
                font-size: $font-size;
                line-height: $font-size*1.8;
                padding-bottom: $font-size*0.2;


                
              }
              .vs{
                transform: skew(#{-0.4deg * $deg});
                margin: 0 0.2rem;
                color: #000;
                font-weight: 600;
              }

              .option-item{
                flex: 1;
                width:34%;
                text-align: center;
                position: relative;
                transform: skew(0);

                span{
                  display: inline-block;
                  
                }

                &.option-yes{
                  background-color: $color-yes;
                  border-radius: 10rem 0 0 10rem;
                  padding-left: $qie-jiao-width;
                  &:before{
                    $width: $qie-jiao-width;
                    transform: skew(#{-1deg * $deg});
                    content:"";
                    position: absolute;
                    right: -$width/2;
                    background-color: inherit;
                    width: $width;
                    height: 100%;
                  }
                }
                &.option-no{
                  background-color: $color-no;
                  border-radius:0 10rem 10rem 0;
                  padding-right: $qie-jiao-width;
                  &:before{
                    $width: $qie-jiao-width;
                    transform: skew(#{-1deg * $deg});
                    content:"";
                    position: absolute;
                    left: -$width/2;
                    background-color: inherit;
                    width: $width;
                    height: 100%;
                  }
                }
              }
            }

          }
          .selected-sum{
            $font-size: 0.11rem;
            line-height: $font-size * 1.5;
            font-size: $font-size;
            display: flex;
            justify-content: space-between;
            background-color: $color-no;
            border-radius: 1rem;
            padding: 0 $font-size;
            margin-top: 0.15rem;
            overflow: hidden;
            position: relative;
            span{
              position: relative;
            }
            .select-yes{
              position: absolute;
              top: 0;
              left:0;
              height: 100%;
              background-color: $color-yes;
              transform: skew(#{-1deg * $deg});
            }
          }
          .win-cash{
            display: flex;
            justify-content: space-between;
            padding: 0.05rem;
            color: #000;
          }
        }
      }

      
      .selecting-option{
        background-color: #000;
        height: 100%;
        .top-ctrl{
          $size:0.25rem;
          height: $size;
          padding: 0.1rem;
          .icon{
            float: right;
            width:$size;
            height: $size;
          }
        }
        .title{
          margin:0.2rem 0.1rem 0;
          // margin-top: 0.2rem;
          text-align: center;
          color: #fff;
          font-size: 0.18rem;
          letter-spacing:0.02rem;
          font-weight: 600;
          padding: 0.1rem 0;
          border-bottom: 1px solid #444;
        }
        .select-option{
          background-color: #000;
          color: #ffc952;
          text-align: center;
          font-size: 0.22rem;
          padding: 0.08rem 0 0.1rem
        }

        .buy-num{
          background-color: #3d3d3d;
          padding: 0.1rem;
          .input-num{
            border-bottom: 1px solid #555;
            // border-bottom: 1px solid #8b8b8b;
            padding-bottom: 0.1rem;
            input{
              width: 100%;
              border: none;
              background: none;
              color: #8b8b8b;
              text-align:center;
            }
          }
          .default-num{
            margin-top: 0.1rem;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            .value{
              $font-size: 0.2rem;
              width: 45%;
              background-color:#6f6f70;
              border-radius: 1rem; 
              text-align: center;
              margin:0.1rem 0;
              font-size: $font-size;
              line-height: $font-size * 1.5
            }
          }
          .can-get{
            font-size: 0.2rem;
            font-weight: 600;
            margin: 0.1rem 0;
            text-align:center;
            .text{
              margin-right: 0.1rem;
            }
            .value{
              color: #ffc952;
            }
          }
        }

        .submit{
          width: 90%;
          margin: 0.2rem auto;
          background: url(../assets/gamble-submit-btn.png) no-repeat center center;
          background-size: 100% 100%;
          $font-size:0.25rem;
          font-size: $font-size;
          line-height: $font-size * 2;
          text-align: center;
          color: #000; 
        }
      }

      .no-game{
        text-align: center;
        display: flex;
        flex-direction: column;
        height: 70%;
        justify-content: center;
        .img{
          .icon{
            margin: 0;
          }
        }
        .tips{
          margin-top: 0.1rem;
          font-size: 0.25rem;
        }
      }


      // ===============================
      .more-option{
        height: 100%;
        .title{
          background-color: #7d88a3;
          font-weight: 600;
          //==================
          // background-color: #7885a3;
          text-align: center;
          $font-size: 0.18rem;
          line-height: $font-size *1.5;
          padding: 0.05rem 0;

          .game-name{
            font-size: $font-size;
            color: #fff;
          }
          .end-time{
            font-size: $font-size * 0.8;
            color: #ffda50;
            position: relative;

            .not-gaming{
              color: #4f586e;
              .cash{
                position: absolute;
                right: 0.1rem;
                color: #ffda50;
                .icon-gold{
                  width: $font-size * 1;
                  height: $font-size * 1;
                  vertical-align: middle;
                  margin-right: 0.01rem;
                }
              }
              
            }
          }
        }
        .options{
          margin: 0.1rem;
          flex:1;
          overflow: scroll;
          .option-item{
            overflow: hidden;
            background-color: #fff;
            margin-top:0.02rem;
            position: relative;
            display: flex;
            .win-icon{
              position: absolute;              
              $margin:0.1rem;
              top: $margin;
              right: $margin;
              height: 0;
              width: 0;
              display: flex;
              justify-content: center;
              align-items: center;
              span{
                $font-size: 0.12rem;
                flex-shrink: 0;
                width: 2rem;
                text-align: center;
                display: block;
                transform: rotateZ(45deg);
                background-color: #f00;
                font-size: $font-size;
                line-height: $font-size *1.2;
                padding-bottom:$font-size * 0.1;
              }
            }
            .option-name{
              $font-size: 0.2rem;
              background-color: #fff;
              color: #000;
              font-size: $font-size;
              line-height: $font-size * 3;
              font-weight: 600;
              // text-align: center;
              padding:0 0.05rem;
              flex:1;


            }
            .btn{
              width: 30%;
              display: flex;
              justify-content: center;
              align-items: center;
              background-color: #ffd44d;
              &.selected{
                background-color: #949494;
                
              }

              .select-btn{
                width: 100%;
                $font-size:0.16rem;
                font-size: $font-size;
                line-height: $font-size * 2;
                text-align: center;
                color: #000; 

                
              }
            }
            /* .option-info{
              display: flex;
              color: #000;
              padding:0.1rem;
              .info{
                width: 60%;
                $margin:0.05rem;
                .select{
                  margin: $margin;
                  .label{
                    color: #fff;
                    background-color: #f1b449;
                    border-radius: 0.05rem;
                    padding:0 0.1rem;
                    font-size: 0.18rem;
                  }
                  .value{
                    margin-left: 0.02rem;
                    font-size: 0.18rem;
                    font-weight: 600;
                  }
                }
                .odds{
                  margin: $margin;
                  font-size: 0.2rem;
                }
              }
              
            } */
          }
          
        }
      }

      
    }
    .reward-rank-comp{
      flex: 1;
      min-height: 0;
      height: 100%;
      display: flex;
      flex-direction: column;
    }

    .rule-show-box{
      flex: 1;
      width: 100%;
      height:100%;
      display: flex;
      flex-direction: column;
      .pop-rule{
        background: rgba(0,0,0,0.6);
        color: #fff;
        text-align: center;
        padding: 0.1rem;
        line-height: 0.3rem;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        .ctrl{
          display: flex;
          justify-content: flex-end;
          margin-bottom: 0.1rem;
        }
        .info{
          overflow: scroll;
          .info-item{
            &:not(:last-child){
              margin-bottom: 0.3rem;
            }
            .title{
              font-size: 0.2rem;
            }
            .text{
              font-size: 0.18rem;
              text-align: left;
            }
          }
          
        }
      }
    }

    
    
  }
</style>
